import { ViewportScroller } from '@angular/common';
import { AfterViewInit, Component, inject, ViewEncapsulation } from '@angular/core';
import { Router, RouterOutlet, Scroll } from '@angular/router';
import { ContextService, getClassNames } from '@bcef/ia-shared';
import { DataLayer } from '@difa/ia-data-layer';
import { TranslateService } from '@ngx-translate/core';
import { clsx } from 'clsx';
import { filter } from 'rxjs';

@Component({
  selector: 'ia-make-complaint-root',
  template: `
    <div [class]="typologies">
      <router-outlet />
    </div>
  `,
  styleUrls: ['./app.component.scss'],
  encapsulation: ViewEncapsulation.ShadowDom,
  imports: [RouterOutlet],
})
export class AppComponent implements AfterViewInit {
  private readonly translate = inject(TranslateService);

  private readonly contextService = inject(ContextService);

  protected readonly _datalayer = inject(DataLayer);

  private readonly router = inject(Router);

  private readonly viewportScroller = inject(ViewportScroller);

  protected typologies: string;

  constructor() {
    this.translate.use(this.contextService.language);
    this.typologies = clsx(getClassNames(this.contextService.typology));
    this.viewportScroller.setOffset([0, 140]);
  }

  public ngAfterViewInit(): void {
    this.router.events.pipe(filter((event) => event instanceof Scroll)).subscribe(({ anchor }) => {
      if (anchor) {
        this.viewportScroller.scrollToAnchor(anchor, {
          behavior: 'smooth',
        });
      }
    });
  }
}
